import axios from 'axios';

import { getRequestAuthPayload } from '../helpers/getRequestAuth';

export const deleteTag = async (id: string): Promise<void> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'delete',
    url: `tags/${id}`,
  });

  await axios(networkPayload);
};
